import { PreguntasTipoEnum } from "@shared/enums";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaURLImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.URL;
    }
}
